import { DICTIONARY_GEOFENCE, EZLO_GEOFENCING, GEOFENCES, GEOFENCES_ALL } from 'containers/Ezlo/EzloMeshbot/constants';

/**
 * Creates a geofence subscription data object for a given user.
 *
 * This object is typically used to subscribe to geofencing updates via a gateway.
 *
 * @param {Object} params - Parameters for subscription.
 * @param {string} params.user - The UUID of the user to subscribe for geofence updates.
 * @returns {Object} Subscription data object formatted for the geofencing gateway.
 *
 * @example
 * createGeofenceSubscriptionData({ user: 'abc-123' });
 * // ➜ {
 * //   uuid: 'abc-123',
 * //   gatewayName: 'ezlo_geofencing',
 * //   capability: 'geofences_all',
 * //   variable: 'geofences',
 * //   valueType: 'dictionary.geofence',
 * //   dictionaryType: true,
 * //   value: {}
 * // }
 */
export const createGeofenceSubscriptionData = ({ user }) => {
    return {
        uuid: user,
        gatewayName: EZLO_GEOFENCING,
        capability: GEOFENCES_ALL,
        variable: GEOFENCES,
        valueType: DICTIONARY_GEOFENCE,
        dictionaryType: true,
        value: {},
    };
};
